//@flow

// Vendors
import React from 'react';
import classnames from 'classnames';

// Components
import InputWrapper from '../InputWrapper';

// Types
type Props = {
  name: string,
  className?: string,
  formikProps: FormikProps,
};

/**
 * @visibleName Numeric
 */
const InputNumeric = ({ className, ...props }: Props) => (
  <InputWrapper
    {...props}
    type="tel"
    className={classnames('input-numeric', className)}
  />
);

export default InputNumeric;
